import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import Swal from 'sweetalert2';
import jwt_decode from 'jwt-decode'
import { AfterViewInit } from '@angular/core';
import { UserApiService } from '../../../app/api/user-api.service';
import { ToastrService } from 'ngx-toastr'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { timer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-reset-password',
	templateUrl: './reset-password.component.html',
	styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, AfterViewInit {

  @ViewChild('password',{ static:false }) password:ElementRef
  @ViewChild('passwordConfirm',{ static:false }) passwordConfirm:ElementRef
  inputValue:FormGroup
	loading:boolean = false
  regexPass = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/

	constructor( 
	  private activateRouter:ActivatedRoute,
		private router:Router,
		private userService:UserApiService,
		private toastr:ToastrService,
    private fb:FormBuilder,
    private translate:TranslateService
		) {
		  this.inputValue = this.fb.group({
         password:["",[
           Validators.required, 
           Validators.minLength(6),
           Validators.pattern(this.regexPass)
           ]],
         passwordConfirm:["",[
           Validators.required,
           Validators.minLength(6),
           Validators.pattern(this.regexPass)
           ]]
      })
	 }
  ngAfterViewInit(): void {
    this.password.nativeElement.focus()
  }

	ngOnInit() {

		
      this.activateRouter.queryParams.pipe(
         map( param => {
			if(!param.token){
			    this.router.navigate(['/'])  
			}else{
				return param
			}
		})
	   ).subscribe(({ token }) => {
		    localStorage.setItem('reset', JSON.stringify(token))
	   })

	}

  validateInput(field){
      return ( 
          ( !this.inputValue.get(field).valid && this.inputValue.get(field).touched )
           ? 'is-invalid' :this.inputValue.get(field).touched 
           ? 'is-valid' : ''
           )
  }

	cambiarpassword(){
      const {password, passwordConfirm} = this.inputValue.value

      if(password !== passwordConfirm ){
         Swal.fire({
           icon:'error',
           title:'Opss',
           text:this.translate.instant('Las contraseñas no coinciden')
         })
         return 
      }
       
       this.loading= true
       setTimeout(()=>{
		   
			this.userService.resetPassword(password, JSON.parse(localStorage.getItem('reset') ) )
			.subscribe(()=>{
			this.toastr.success(this.translate.instant('password cambiado exitosamente'))
			this.router.navigate(['/'])
			this.loading= false
			 localStorage.removeItem('reset')
			},err=>{
				this.toastr.error( this.translate.instant('El token no es valido o ha expirado') )
				this.loading= false
			})
	   },3000)
	
	} 
 
	mostrarpass(){
   this.password.nativeElement.type ==='password'
      ?  this.password.nativeElement.type ='text'
      :  this.password.nativeElement.type ='password'
  
  }

	mostrarpassreset(){
     this.passwordConfirm.nativeElement.type ==='password'
      ?  this.passwordConfirm.nativeElement.type ='text'
      :  this.passwordConfirm.nativeElement.type ='password'
  }

  cambiarIdioma(lang){
      this.translate.use(lang)
  }

}